import styled from "styled-components";
import SearchSecondary from "../../components/SearchSecondary";

export const Container = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  height: 100%;
`;

export const HeaderInputs = styled.div`
  display: flex;
  width: 100%;
  padding: 24px 16px;
  align-items: center;
`;

export const StyledSearchSecondary = styled(SearchSecondary)`
  max-width: 75% !important;
  min-width: 650px !important;

  & svg {
    fill: #fff !important;
  }
`;


export const NotesConnectionHeader = styled.div`
  background-color: var(--luft-secondary);
  display: flex;
  flex-direction: column;
  padding-top: 16px;

  h1 {
    margin-left: 16px;
  }
`;

export const NotesConnectionContent = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
`;
